// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
	apiKey: "AIzaSyDnmUv994648FExDTgRNmDYdFrbjGc39_g",
	authDomain: "academia-cenit.firebaseapp.com",
	projectId: "academia-cenit",
	storageBucket: "academia-cenit.firebasestorage.app",
	messagingSenderId: "461735853271",
	appId: "1:461735853271:web:53d5e06ba7c4acf7954492",
	databaseURL: "https://academia-cenit-default-rtdb.firebaseio.com",
};
// const firebaseConfig = {
//   apiKey: "AIzaSyAJCb5O40qe8ugkRnkmOW7ty-CxK1v4WcY",
//   authDomain: "cenit-quitar.firebaseapp.com",
//   projectId: "cenit-quitar",
//   storageBucket: "cenit-quitar.firebasestorage.app",
//   messagingSenderId: "857760177559",
//   appId: "1:857760177559:web:36cb864143311a54f478d2"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const storage = getStorage(app);
